import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

type PassFailChipProps = {
  error: number | null;
  tolerance: number;
  prefix?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
};

const getPassFailStatus = (
  error: number | null,
  tolerance: number
): 'pass' | 'fail' | 'none' => {
  if (error === null) return 'none';

  return Math.abs(error) > tolerance ? 'fail' : 'pass';
};

export const PassFailChip: React.FC<PassFailChipProps> = ({
  error,
  tolerance,
  prefix = '',
  size = 'small',
  fullWidth = false
}) => {
  const { t } = useTranslation('calibration');
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const status = getPassFailStatus(error, tolerance);

  if (status === 'none') return null;

  const label = prefix
    ? `${prefix}: ${t(`testGrid.${status}`)}`
    : t(`testGrid.${status}`);

  const color = status === 'pass' ? 'success' : 'error';

  const darkModeSx = isDarkMode
    ? {
        backgroundColor:
          status === 'pass'
            ? 'rgba(16, 185, 129, 0.3)'
            : 'rgba(239, 68, 68, 0.3)',
        color:
          status === 'pass' ? 'rgba(52, 211, 153, 1)' : 'rgba(248, 113, 113, 1)'
      }
    : {};

  return (
    <Chip
      label={label}
      color={color}
      size={size}
      sx={{
        ...(fullWidth ? { width: '100%' } : {}),
        fontWeight: 600,
        ...darkModeSx
      }}
    />
  );
};
